module.exports = __webpack_public_path__ + "img/gongzhonghao.43601023.png";